import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import ScreenRotationIcon from '@mui/icons-material/ScreenRotation';
import { shouldShowOrientationWarning } from '../../utils/deviceDetection';

/**
 * OrientationWarning component
 * Displays a full-screen overlay when MOBILE device is in landscape mode
 * Desktop devices are not affected
 */
const OrientationWarning: React.FC = () => {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      // Only show warning on mobile devices in landscape
      setShowWarning(shouldShowOrientationWarning());
    };

    // Check on mount
    checkOrientation();

    // Listen for orientation changes
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  if (!showWarning) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#1a1a1a',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 4,
        textAlign: 'center',
      }}
    >
      <ScreenRotationIcon
        sx={{
          fontSize: '5rem',
          color: 'var(--primary-colour)',
          mb: 3,
          animation: 'rotate 2s ease-in-out infinite',
          '@keyframes rotate': {
            '0%, 100%': {
              transform: 'rotate(0deg)',
            },
            '50%': {
              transform: 'rotate(90deg)',
            },
          },
        }}
      />
      <Typography
        variant="h5"
        sx={{
          color: '#f5f5f5',
          fontWeight: 600,
          mb: 2,
        }}
      >
        Please Rotate Your Device
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: 'rgba(255, 255, 255, 0.7)',
          maxWidth: '400px',
        }}
      >
        This app works best in portrait mode. Please rotate your device to continue.
      </Typography>
    </Box>
  );
};

export default OrientationWarning;
